<template>
  <ValidationObserver class="d-flex overflow-hidden" v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="xl" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :visible="modal.show"
                   :title="title" :ok-title="$t('Submit')" modal-class="mobile-full-screen"
                   :is-loading="modal.loading || progressData.loading"
                   :no-close-on-backdrop="progressData.loading"
                   :no-close-on-esc="progressData.loading"
                   :hide-header-close="progressData.loading"
                   scrollable body-class="continuous-auction-batch-lot-up" @show="onShow">
      <spinner v-if="modal.loading" show/>
      <div v-else-if="progressData.loading" class="d-flex" style="flex: 1">
        <spinner style="flex: 1" height="10" spinner-size="3"
                 :text="$t('Loading {percentage}%', {'percentage': progressData.value})" show/>
      </div>
      <div class="d-flex overflow-hidden flex-column" v-else>

        <div class="row">
          <div class="col-md-12">
            <input-widget :model="batchEditModel" attribute="set_date_by_batch" type="checkbox" is-switch/>
          </div>
          <div class="col-md-2" v-if="batchEditModel.set_date_by_batch">
            <input-widget :model="batchEditModel" attribute="start_date" type="datepicker"
                          :min="$options.filters.currentDate()" @change="onBatchEditStartDateChange"/>
          </div>
          <div class="col-md-2" v-if="batchEditModel.set_date_by_batch">
            <input-widget :model="batchEditModel" attribute="start_time" type="timepicker"
                          @change="onBatchEditStartTimeChange"/>
          </div>
          <div class="col-md-2" v-if="batchEditModel.set_date_by_batch">
            <input-widget :model="batchEditModel" attribute="end_date" type="datepicker"
                          :min="$options.filters.currentDate()" @change="onBatchEditEndDateChange"/>
          </div>
          <div class="col-md-2" v-if="batchEditModel.set_date_by_batch">
            <input-widget :model="batchEditModel" attribute="end_time" type="timepicker"
                          @change="onBatchEditEndTimeChange"/>
          </div>

        </div>

        <artisio-table v-if="models && models.length > 0" :items="models" :fields="tableFields"
                       :index="false">

          <template #cell(title)="{item: model}">
            {{ model.stock_no }} - {{ model.title | striptags | truncate(200) }}
          </template>
          <template #cell(start_date)="{item: model}">
            <input-widget :label="false" :model="model" attribute="start_date" type="datepicker"
                          :min="$options.filters.currentDate()"/>
          </template>
          <template #cell(start_time)="{item: model}">
            <input-widget :label="false" :model="model" attribute="start_time" type="timepicker"/>
          </template>
          <template #cell(end_date)="{item: model}">
            <input-widget :label="false" :model="model" attribute="end_date" type="datepicker"
                          :min="$options.filters.currentDate()"/>
          </template>
          <template #cell(end_time)="{item: model}">
            <input-widget :label="false" :model="model" attribute="end_time" type="timepicker"/>
          </template>
          <template #cell(total_quantity)="{item: model}">
            {{ model.total_quantity }}
          </template>
          <template #cell(available_quantity)="{item: model}">
            {{ model.available_quantity }}
          </template>
          <template #cell(reserve_quantity)="{item: model}">
            <input-widget
                :rules="`required|max_value:${Math.floor(model.available_quantity/model.reserve_number)}|min_value:1`"
                :model="model" type="number"
                attribute="reserve_quantity" :label="false"/>
          </template>
          <template #cell(reserve_number)="{item: model}">
            <input-widget
                :rules="`required|max_value:${Math.floor(model.available_quantity/model.reserve_quantity)}|min_value:1`"
                :model="model" type="number"
                attribute="reserve_number" :label="false"/>
          </template>
          <template #cell(start_price)="{item: model}">
            <input-widget :model="model" type="number" attribute="start_price" :label="false"/>
          </template>
          <template #cell(reserve)="{item: model}">
            <input-widget :model="model" type="number" attribute="reserve" :label="false"/>
          </template>
        </artisio-table>

      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import Spinner from "@/core/components/common/Spinner";
  import ContinuousAuctionBatchLotUpModel
    from "@/modules/inventory/continuous-auction-batch-lot-up-modal/ContinuousAuctionBatchLotUpModel.model";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable";
  import InventoryService from "@/modules/inventory/InventoryService";
  import {Formatter} from "@/core/services/formatter.service";
  import {
    SOURCE_INVENTORY_TABLE,
    WS_CONTINUOUS_AUCTION_BATCH_LOT_UP_PROGRESS,
  } from "@/modules/constants";
  import ContinuousAuctionBatchLotUpBatchEditModel
    from "@/modules/inventory/continuous-auction-batch-lot-up-modal/ContinuousAuctionBatchLotUpBatchEditModel.model";

  const {mapActions, mapState} = createNamespacedHelpers('inventory');
  const {mapActions: mapGlobalActions} = createNamespacedHelpers('global');

  export default {
    name: "ContinuousAuctionBatchLotUp",
    components: {
      ArtisioTable,
      InputWidget,
      Spinner,
      ArtisioModal,
    },
    data() {
      return {
        batchEditModel: new ContinuousAuctionBatchLotUpBatchEditModel(),
        models: [],
        tableFields: [
          {key: "title", label: this.$i18n.t('Title'), sortable: false, stickyColumn: true, tdClass: "title-col",},
          {key: "start_date", label: this.$i18n.t('Start Date'), sortable: false, tdClass: "date-col"},
          {key: "start_time", label: this.$i18n.t('Start Time'), sortable: false, tdClass: 'time-col'},
          {key: "end_date", label: this.$i18n.t('End Date'), sortable: false, tdClass: "date-col"},
          {key: "end_time", label: this.$i18n.t('End Time'), sortable: false, tdClass: 'time-col'},
          {key: "start_price", label: this.$i18n.t('Start Price'), sortable: false, tdClass: "start-price-col"},
          {key: "reserve", label: this.$i18n.t('Reserve'), sortable: false, tdClass: "reserve-col"},
          {key: "total_quantity", label: this.$i18n.t('Total Quantity'), sortable: false},
          {key: "available_quantity", label: this.$i18n.t('Available Quantity'), sortable: false},
          {key: "reserve_quantity", label: this.$i18n.t('Reserve Quantity'), sortable: false},
          {key: "reserve_number", label: this.$i18n.t('Number of Reserves'), sortable: false},
        ],
        progressData: {
          loading: false,
          value: 0
        }
      }
    },
    computed: {
      ...mapState({
        modal: state => state.continuousAuctionBatchLotUpModal,
        items: state => state.continuousAuctionBatchLotUpModal.items,
      }),
      title() {
        return this.$i18n.t("Batch Lot Up")
      }
    },
    watch: {
      items() {
        this.items.forEach(item => {
          let model = new ContinuousAuctionBatchLotUpModel({
            "stock_no": item.stock_no,
            "inventory_uuid": item.uuid,
            "title": item.short_description,
            "total_quantity": item.quantity,
            "reservations": item.reservations,
            "available_quantity": item.available_quantity,
            "start_price": item.start_price,
            "reserve": item.reserve,
          });
          this.configureContinuousAuctionLotFormDefaultDatesConfiguration(model);
          this.models.push(model);
        })
      }
    },
    methods: {
      ...mapActions([
        "hideContinuousAuctionBatchLotUpModal",
        "getTableData",
        "toggleContinuousAuctionBatchLotUpModalLoading"
      ]),
      ...mapGlobalActions(['configureContinuousAuctionLotFormDefaultDatesConfiguration']),
      onHidden() {
        this.batchEditModel = new ContinuousAuctionBatchLotUpBatchEditModel()
        this.models = [];
        this.hideContinuousAuctionBatchLotUpModal();
        this.progressData.loading = false
        this.progressData.value = 0
        this.$ws.remove(`inventories.${WS_CONTINUOUS_AUCTION_BATCH_LOT_UP_PROGRESS}`);
      },
      onShow() {
        this.$ws.listen(`inventories.${WS_CONTINUOUS_AUCTION_BATCH_LOT_UP_PROGRESS}`, this.handleContinuousAuctionsBatchLotUpProgress);
      },
      async onSubmit() {
        let requestData = [];
        this.models.forEach(m => {
          requestData.push({
            uuid: m.inventory_uuid,
            reserve_quantity: m.reserve_quantity,
            reserve_number: m.reserve_number,
            start_price: m.start_price,
            reserve: m.reserve,
            start_date: Formatter.getDateAndTimeToSystemFormat(m.start_date, m.start_time),
            end_date: Formatter.getDateAndTimeToSystemFormat(m.end_date, m.end_time),
          })
        })
        this.toggleContinuousAuctionBatchLotUpModalLoading(true)
        let response = await InventoryService.continuousAuctionBatchLotUp(requestData);
        this.toggleContinuousAuctionBatchLotUpModalLoading(false)
        if (response.success) {
          this.progressData.loading = true;
          this.$toast('success', this.$t('Lots generation was successfully started.'));
        } else {
          this.handleErrors(response.body)
        }
      },
      handleErrors(body) {
        if (body.non_field_errors) {
          const listItemsArr = [];
          body.non_field_errors.forEach(e => listItemsArr.push(this.$createElement('li', {}, e)))
          if (listItemsArr.length > 0) {
            this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t('Validation Error'));
          } else {
            this.$errorDialog(this.$i18n.t("Something went wrong. Please, try again later."));
          }
        } else if (body.mapped_errors) {
          let errData = body.mapped_errors;
          const listItemsArr = [];

          for (let stockNo in errData) {
            let err = errData[stockNo];
            if (typeof err === 'object') {
              if (err.dates && typeof err.dates === 'object' && err.dates.length > 0) {
                for (let key in err.dates[0]) {
                  if (err.dates[0][key] && err.dates[0][key][0]) {
                    let msg = `Error while handling item ${stockNo}. Error: ${err.dates[0][key][0]}`
                    listItemsArr.push(this.$createElement('li', {}, msg));
                  }
                }
              } else {
                for (let i in err) {
                  if (typeof err[i] === 'object' && err[i].length > 0) {
                    for (let j of err[i]) {
                      let msg = `Error while handling item ${stockNo}. Error: ${j}`
                      listItemsArr.push(this.$createElement('li', {}, msg));
                    }
                  }
                }
              }
            }
          }

          if (listItemsArr.length > 0) {
            this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t('Validation Error'));
          } else {
            this.$errorDialog(this.$i18n.t("Something went wrong. Please, try again later."));
          }
        } else {
          this.$errorDialog(this.$i18n.t("Something went wrong. Please, try again later."));
        }
      },
      async handleContinuousAuctionsBatchLotUpProgress(payload) {
        if (payload.is_finished) {
          this.progressData.loading = false
          this.progressData.value = 0
          if (!payload.errors) {
            this.$toast('success', this.$t('Lots were successfully generated.'));
            if (this.modal.source === SOURCE_INVENTORY_TABLE) {
              this.getTableData();
            }
            this.hideContinuousAuctionBatchLotUpModal();
          } else {
            this.handleErrors(payload.errors);
          }
        } else {
          this.progressData.value = parseInt(Math.round(payload.successful / payload.total * 100))
        }
      },
      onBatchEditStartDateChange(val) {
        this.models.forEach(m => m.start_date = val)
      },
      onBatchEditEndDateChange(val) {
        this.models.forEach(m => m.end_date = val)
      },
      onBatchEditStartTimeChange(val) {
        this.models.forEach(m => m.start_time = val)
      },
      onBatchEditEndTimeChange(val) {
        this.models.forEach(m => m.end_time = val)
      }
    }
  }
</script>

<style lang="scss">
  .continuous-auction-batch-lot-up {
    overflow: hidden;
    display: flex;

    form {
      overflow: hidden;
      display: flex;
      flex: 1;
      justify-content: center;

      .artisio-table {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        td {
          white-space: normal;
        }

        .start-price-col {
          min-width: 120px;
          white-space: normal;

        }

        .reserve-col {
          min-width: 120px;
        }

        .date-col {
          min-width: 180px;
        }

        .time-col {
          min-width: 170px;
        }

        .table-content {
          display: flex;
          overflow: auto;
        }

        .title-col {
          max-width: 250px;
          min-width: 250px;
        }
      }
    }
  }

</style>
